import http from "../plugins/http/http";
export default {
    load_profile({ commit, state }, data) {
        return new Promise((resolve, reject) => {
            if (state.profile.id) {
                resolve(true);
            } else {
 
                http.get("/personal/profile")
                    .then((response) => {
                        if (response.success) {
                            commit("changeProfile", response.success ? response.data : this.$store.state._profile);
                        }
                        resolve(response.success);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            }
        });
    },
};
